import { render, staticRenderFns } from "./PopupVideoPlayer.vue?vue&type=template&id=1787ac3a&scoped=true&"
import script from "./PopupVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./PopupVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./PopupVideoPlayer.vue?vue&type=style&index=0&id=1787ac3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787ac3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1787ac3a')) {
      api.createRecord('1787ac3a', component.options)
    } else {
      api.reload('1787ac3a', component.options)
    }
    module.hot.accept("./PopupVideoPlayer.vue?vue&type=template&id=1787ac3a&scoped=true&", function () {
      api.rerender('1787ac3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/popup/PopupVideoPlayer.vue"
export default component.exports